export default __webpack_public_path__ + "static/media/roast-chicken.514cf848.svg";